// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3BKrR","info":"PatientInfo_info__1dqGo"};